'use client';

import { useTranslations } from 'next-intl';
import { IconButton, Tooltip } from '@terra/ui-design-system';
import { RefreshIcon } from '@terra/ui-icons';

export function ListPageRefreshButton({
  onRefresh,
  isLoading,
}: {
  onRefresh: () => void;
  isLoading: boolean;
}) {
  const tCommon = useTranslations('common');

  return (
    <Tooltip title={tCommon('refresh')}>
      <IconButton
        size="2xs"
        variant="outline"
        onClick={onRefresh}
        disabled={isLoading}
        aria-label={tCommon('refresh')}
      >
        <RefreshIcon
          size={14}
          style={{
            animation: isLoading ? 'spin 1s linear infinite' : 'none',
          }}
        />
      </IconButton>
    </Tooltip>
  );
}
